!function (t, i) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = i() : "function" == typeof define && define.amd ? define("Fireworks", i) : (t = t || self).Fireworks = i();
}(this, function () {
  "use strict";

  function t(t, i) {
    return Math.random() * (i - t) + t;
  }

  var i = 2 * Math.PI,
      s = function () {
    function s(s) {
      var e = s.isRocket,
          n = void 0 !== e && e,
          o = s.hue,
          h = void 0 === o ? t(1, 360) : o,
          r = s.brightness,
          a = void 0 === r ? t(50, 60) : r,
          c = s.position;
      if (this.isRocket = n, this.position = c, this.positions = [this.position, this.position, this.position], this.isRocket) this.velocity = {
        x: t(-3, 3),
        y: t(-7, -3)
      }, this.shrink = .999, this.resistance = 1;else {
        var l = t(0, i),
            p = 15 * Math.cos(t(0, i));
        this.velocity = {
          x: Math.cos(l) * p,
          y: Math.sin(l) * p
        }, this.shrink = t(0, .05) + .93, this.resistance = .92;
      }
      this.gravity = .01, this.size = 3, this.alpha = 1, this.fade = 0, this.hue = h, this.brightness = a;
    }

    return s.prototype.clone = function () {
      return new s({
        position: {
          x: this.position.x,
          y: this.position.y
        },
        hue: this.hue,
        brightness: this.brightness
      });
    }, s.prototype.shouldRemove = function (t, i) {
      return this.alpha <= .1 || this.size <= 1 || this.position.x > t || this.position.x < 0 || this.position.y > i || this.position.y < 0;
    }, s.prototype.shouldExplode = function (i, s, e) {
      return !!this.isRocket && (this.position.y <= i || !(this.position.y >= s) && t(0, 1) <= e);
    }, s.prototype.update = function () {
      this.positions.pop(), this.positions.unshift({
        x: this.position.x,
        y: this.position.y
      }), this.velocity.x *= this.resistance, this.velocity.y *= this.resistance, this.velocity.y += this.gravity, this.position.x += this.velocity.x, this.position.y += this.velocity.y, this.size *= this.shrink, this.alpha -= this.fade;
    }, s.prototype.draw = function (t) {
      var i = this.positions[this.positions.length - 1];
      t.beginPath(), t.moveTo(i.x, i.y), t.lineTo(this.position.x, this.position.y), t.lineWidth = this.size, t.strokeStyle = "hsla(" + this.hue + ", 100%, " + this.brightness + "%, " + this.alpha + ")", t.stroke();
    }, s;
  }(),
      e = function () {
    function i(t) {
      var i = t.maxRockets,
          s = t.numParticles,
          e = t.cw,
          n = t.ch;
      this._set = new Set(), this.rockets = 0, this.maxRockets = i, this.numParticles = s, this.cw = e, this.ch = n;
    }

    return i.prototype.size = function () {
      return this._set.size;
    }, i.prototype.entries = function () {
      return this._set;
    }, i.prototype.clear = function () {
      this._set.clear();
    }, i.prototype.delete = function (t) {
      this._set.delete(t);
    }, i.prototype.add = function (t) {
      this._set.add(t);
    }, i.prototype.explode = function (t) {
      this.rockets--;

      for (var i = 0; i < this.numParticles; i += 1) {
        this.add(t.clone());
      }

      this.delete(t);
    }, i.prototype.spawnRocket = function () {
      this.rockets++, this.add(new s({
        isRocket: !0,
        position: {
          x: t(0, this.cw),
          y: this.ch
        }
      }));
    }, i.prototype.spawnRockets = function () {
      this.rockets < this.maxRockets && this.spawnRocket();
    }, i;
  }();

  return function () {
    function t(t, i) {
      var s = void 0 === i ? {} : i,
          n = s.rocketSpawnInterval,
          o = void 0 === n ? 150 : n,
          h = s.maxRockets,
          r = void 0 === h ? 3 : h,
          a = s.numParticles,
          c = void 0 === a ? 100 : a,
          l = s.explosionMinHeight,
          p = void 0 === l ? .2 : l,
          u = s.explosionMaxHeight,
          d = void 0 === u ? .9 : u,
          f = s.explosionChance,
          v = void 0 === f ? .08 : f;
      this.rocketSpawnInterval = o, this.maxRockets = r, this.cw = t.clientWidth, this.ch = t.clientHeight, this.max_h = this.ch * (1 - d), this.min_h = this.ch * (1 - p), this.chance = v, this.canvas = document.createElement("canvas"), this.canvas.width = this.cw, this.canvas.height = this.ch, this.ctx = this.canvas.getContext("2d"), t.appendChild(this.canvas), this.things = new e({
        maxRockets: this.maxRockets,
        numParticles: c,
        cw: this.cw,
        ch: this.ch
      });
    }

    return t.prototype.destroy = function () {
      this.canvas.parentElement.removeChild(this.canvas), window.clearInterval(this.interval), window.cancelAnimationFrame(this.rafInterval);
    }, t.prototype.start = function () {
      var t = this;
      return this.maxRockets > 0 && (this.interval = window.setInterval(function () {
        return t.things.spawnRockets();
      }, this.rocketSpawnInterval), this.rafInterval = window.requestAnimationFrame(function () {
        return t.update();
      })), function () {
        return t.stop();
      };
    }, t.prototype.stop = function () {
      window.clearInterval(this.interval), this.interval = null;
    }, t.prototype.kill = function () {
      this.things.clear(), this.stop(), window.cancelAnimationFrame(this.rafInterval), this.rafInterval = null, this._clear(!0);
    }, t.prototype.fire = function () {
      var t = this;
      this.things.spawnRocket(), this.rafInterval || (this.rafInterval = window.requestAnimationFrame(function () {
        return t.update();
      }));
    }, t.prototype._clear = function (t) {
      void 0 === t && (t = !1), this.ctx.globalCompositeOperation = "destination-out", this.ctx.fillStyle = "rgba(0, 0, 0 " + (t ? "" : ", 0.5") + ")", this.ctx.fillRect(0, 0, this.cw, this.ch), this.ctx.globalCompositeOperation = "lighter";
    }, t.prototype.update = function () {
      var t,
          i,
          s = this;

      this._clear();

      try {
        for (var e = function (t) {
          var i = "function" == typeof Symbol && t[Symbol.iterator],
              s = 0;
          return i ? i.call(t) : {
            next: function next() {
              return t && s >= t.length && (t = void 0), {
                value: t && t[s++],
                done: !t
              };
            }
          };
        }(this.things.entries()), n = e.next(); !n.done; n = e.next()) {
          var o = n.value;
          o.draw(this.ctx), o.update(), o.shouldRemove(this.cw, this.ch) ? this.things.delete(o) : o.shouldExplode(this.max_h, this.min_h, this.chance) && this.things.explode(o);
        }
      } catch (i) {
        t = {
          error: i
        };
      } finally {
        try {
          n && !n.done && (i = e.return) && i.call(e);
        } finally {
          if (t) throw t.error;
        }
      }

      this.interval || this.things.size() > 0 ? this.rafInterval = window.requestAnimationFrame(function () {
        return s.update();
      }) : (this._clear(!0), this.rafInterval = null);
    }, t;
  }();
});